import {
  Box,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Theme,
  Typography,
  withStyles
} from "@material-ui/core";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";

const Card = styled(MuiCard)(spacing);
const CardContent = withStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gridGap: "10px",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
      flexDirection: "column"
    },
    padding: "16px"
  }
}))(MuiCardContent);

type PropsType = {
  name: string
}

const NameBlock: FC<PropsType> = ({name}) => {
  const {t} = useTranslation();

  return (
    <Card style={{margin: "20px 0"}}>
      <CardContent>
        <Box>
          <Box mt={1}>
            <Typography variant="h6" gutterBottom>
              {name}
            </Typography>
          </Box>
          <Box>
            <Typography>{t('CLP_The_purpose_of_Handiscover_1')}</Typography>
            <Typography>{t('CLP_The_purpose_of_Handiscover_2')}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default NameBlock
